import { ExclamationCircleFilled } from '@ant-design/icons';
import { Alert, Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface CloseDraftConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  translationPrefix?: string;
}

export default function CloseDraftConfirmationModal({
  open,
  onCancel,
  onConfirm,
  translationPrefix = 'ajout_dossier:close_confirm',
}: CloseDraftConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      centered
      onCancel={onCancel}
      footer={null}
      closable={false}
      className="lg:[&_.ant-modal-content]:mx-32 [&_.ant-modal-body]:!px-10 [&_.ant-modal-body]:!py-9 [&_.ant-modal-body]:!rounded-xl"
    >
      <Alert
        type="warning"
        showIcon
        icon={
          <ExclamationCircleFilled className="text-orange-particuliers-6" />
        }
        message={
          <span className="font-semibold text-gray-800">
            {t(`${translationPrefix}:title`)}
          </span>
        }
        description={
          <span className="text-gray-700">{t(`${translationPrefix}:text`)}</span>
        }
        className="!rounded-2xl !border-0 !bg-orange-particuliers-1 !px-7 !py-6 [&_.ant-alert-message]:!mb-4 !items-start"
      />

      <div className="mt-8 flex items-center justify-between gap-6">
        <Button
          type="link"
          onClick={onCancel}
          className="text-bleu-hellio font-semibold hover:text-bleu-hellio-600 transition-colors"
        >
          {t(`${translationPrefix}:cancel_cta`)}
        </Button>
        <Button type="primary" shape="round" size="large" onClick={onConfirm}>
          {t(`${translationPrefix}:confirm_cta`)}
        </Button>
      </div>
    </Modal>
  );
}
